module.exports = __webpack_public_path__ + "img/image_part_004.c4304432.jpg";